import { render } from "./NotificationBatchExport.vue?vue&type=template&id=6629f947&scoped=true&ts=true"
import script from "./NotificationBatchExport.vue?vue&type=script&lang=ts"
export * from "./NotificationBatchExport.vue?vue&type=script&lang=ts"

import "./NotificationBatchExport.vue?vue&type=style&index=0&id=6629f947&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6629f947"]])

export default __exports__